import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import KAKAOSYMBOL from "../../assets/images/kakao_symbol.png";
import GOOGLESYMBOL from "../../assets/images/google_symbol.png";
// import KAKAOLOGINIMG from "../../assets/images/kakao_login_large_narrow.png";
// import GOOGLELOGINIMG from "../../assets/images/ios_light_sq_SU@3x.png";
import APPLELOGINIMG from "../../assets/images/appleid_button@7x.png";

import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { AuthStateContext } from "../../contexts/AuthStateContext";
import { authAxios } from "../../framework/api";
import { loginTokenKey, setItem } from "../../utils/localStorage";
import NaverLogin from "../../components/AppNaverLogin2";

const KAKAO_REST_API_KEY = process.env.REACT_APP_KAKAO_KEY;
const redirect_uri_kakao = `${process.env.REACT_APP_ROOT_URL}/app/login/kakao/redirect`;

const isIOSMobile = () => {
  if (typeof navigator === "undefined") return false;
  return (
    /iPhone|iPad|iPod/.test(navigator.userAgent) &&
    /Mobile/.test(navigator.userAgent)
  );
};

export default function AppLoginPage() {
  const navigate = useNavigate();
  const { authState, handleChangeAuthState } = useContext(AuthStateContext);

  const onClickKakaoLogin = () => {
    console.log(redirect_uri_kakao);
    const kakaoURL = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_REST_API_KEY}&redirect_uri=${redirect_uri_kakao}&prompt=select_account`;
    window.location.href = kakaoURL;
  };

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );
        if (res.status === 200) {
          const socialLogin = await authAxios.post(`/mobile/auth/social`, {
            type: "google",
            socialId: res.data.id,
            email: res.data.email,
          });
          //console.log(socialLogin);
          console.log("googleLogin");

          if (socialLogin.status === 201 || socialLogin.status === 200) {
            setItem(loginTokenKey, socialLogin.data);
            handleChangeAuthState(true);
            navigate("/app", { replace: true });
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
        }
      }
    },

    onError: () => {
      //console.log("login fail");
    },
  });

  useEffect(() => {
    if (authState) {
      navigate("/app", { replace: true });
    } else {
      // 세션 스토리지에 저장된 sessionSaveData 정보를 가져온다.
      const sessionSaveData = sessionStorage.getItem("sessionSaveData");
      if (sessionSaveData) {
        const parsedData = JSON.parse(sessionSaveData);
        console.log("parsedData", parsedData);
      }
    }
  }, [authState, navigate]);
  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-2">
      <div className="w-full flex flex-col items-center justify-center p-2">
        <header className="mb-10 text-2xl font-extrabold">이규호 만세력</header>
        <div className="w-full text-base text-black text-center mt-10 bg-[#EEE6FF] border border-[#9D7FDE] rounded-xl p-2">
          <p>이규호 만세력 회원이 되시면</p>
          <span className="flex items-center justify-center">
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: "10px" }}
            >
              <path
                opacity="0.8"
                d="M12 0L13.4425 4.5575L18 6L13.4425 7.4425L12 12L10.5575 7.4425L6 6L10.5575 4.5575L12 0Z"
                fill="url(#paint0_linear_0_1)"
              />
              <path
                opacity="0.8"
                d="M4 8L4.96167 11.0383L8 12L4.96167 12.9617L4 16L3.03833 12.9617L0 12L3.03833 11.0383L4 8Z"
                fill="url(#paint1_linear_0_1)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_0_1"
                  x1="18"
                  y1="-1.21395"
                  x2="5.16711"
                  y2="-0.132614"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00CEFF" />
                  <stop offset="0.5" stop-color="#A84EFF" />
                  <stop offset="1" stop-color="#FF0087" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_0_1"
                  x1="8"
                  y1="7.1907"
                  x2="-0.555257"
                  y2="7.91159"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00CEFF" />
                  <stop offset="0.5" stop-color="#A84EFF" />
                  <stop offset="1" stop-color="#FF0087" />
                </linearGradient>
              </defs>
            </svg>
            <p>
              <span className="font-bold">무료 AI 사주 분석</span>을
            </p>
          </span>
          <p>이용하실 수 있습니다</p>
        </div>
        <div className="text-base text-black font-extrabold text-center my-10">
          로그인 하기
        </div>
        <div className="flex flex-col items-center justify-center w-full gap-3 ">
          <button
            onClick={onClickKakaoLogin}
            className="w-[180px] h-[39px] rounded-[4px] flex justify-between items-center bg-[#FEE500] text-[#000000] text-[13px] font-semibold font-[Pretendard] px-3"
          >
            <img src={KAKAOSYMBOL} alt="kako_symbol" className="w-5" />
            <p>카카오 아이디로 로그인</p>
          </button>

          <NaverLogin />
          <button
            onClick={() => {
              console.log("googleLogin");
              // login();
            }}
            className="w-[180px] h-[39px] rounded-[4px] bg-white border border-black flex justify-between items-center text-[#000000] text-[12px] font-semibold font-[Pretendard] px-3"
          >
            {/* <img src={GOOGLELOGINIMG} loading="lazy" alt="google logo" /> */}
            <img src={GOOGLESYMBOL} alt="google_symbol" className="w-5" />
            <p>Google 아이디로 로그인</p>
          </button>

          {/* userAgent check only IOS mobile visible */}
          {isIOSMobile() && (
            <button
              onClick={() => {
                console.log("appleLogin");
              }}
              className="w-[180px]"
            >
              <img src={APPLELOGINIMG} alt="apple_login_middle" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
